import React from 'react'
import {
    Row, Col,
    Card, CardBody, CardTitle
} from "reactstrap";
  
const IconTile = (props) => {
    const {name, value, icon, color, cardStyle} = props

    return(
        <Card className="card-stats" style={cardStyle}>
            <CardBody>
                <Row>
                    <Col md="4" >
                    <div className={`icon-big text-center icon-${color.icon}`}>
                        <i className={`${icon} text-${color.icon}`} />
                    </div>
                    </Col>
                    <Col md="8">
                        <div className="numbers">
                            <p className="card-category">{name}</p>
                            <CardTitle tag="p">{value}</CardTitle>
                            <p />
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}
export default IconTile
